import { AuthenticationType } from '../../../types';
import InfoPopup from '../../toggles-popups/InfoPopup';
import { Switch } from 'src/components/atoms';

interface Props {
  authType: AuthenticationType;
  toggle2fa: (newToggleValue: boolean) => void;
  toggleInfoElement: () => void;
  showInfoElement: boolean;
}

const Vault2faInput = (props: Props) => {
  return (
    <div className="authentication-admin-sso-menu">
      <div className="authentication-admin-subheader" />
      <div className="authentication-admin-2fa-menu">
        <Switch
          onClick={props.toggle2fa}
          checked={props.authType === AuthenticationType.VAULT_2FA}
          data-testid="2fa-toggle"
        />{' '}
        <span className="toggle-label">
          Enable Two Factor Authentication for Resolution Hub users
          (recommended)
        </span>
        <InfoPopup
          handleClickAway={props.toggleInfoElement}
          show={props.showInfoElement}
          anchorEl={document.getElementById('2fa-info') as HTMLElement}
          placement="bottom-start"
        >
          <div className="info-box-container">
            <p className="info-description">
              When Two Factor Authentication is enabled, in addition to their
              password, Resolution Hub users will need to enter a code, sent via
              email, when they attempt to log in.
            </p>
            <p className="info-description">This does not affect App users.</p>
          </div>
        </InfoPopup>
      </div>
    </div>
  );
};

export default Vault2faInput;
